import { parsePhoneNumber } from 'libphonenumber-js';
import { useMemo } from 'react';

export const useSMSUserData = (userDataIsValid: boolean, userData: string) => {
  const userDataParsed = useMemo(
    () => (userDataIsValid ? JSON.parse(userData) : {}),
    [userDataIsValid, userData],
  );

  let userCountryCode;
  const phoneNumber = userDataParsed?.phoneNumber;

  try {
    if (phoneNumber) {
      // https://github.com/catamphetamine/libphonenumber-js#parsephonenumberstring-defaultcountry-string--options-object-phonenumber
      userCountryCode = parsePhoneNumber(phoneNumber?.toString())?.country;
    }
  } catch {
    // `userCountryCode` should still be undefined if there is an error parsing the phone number
  }

  /**
   * @see https://github.com/Iterable/iterable-frontend/pull/10890#discussion_r1283494480 for context on why we are defaulting to US/CA if the country code cannot be determined.
   */
  const userIsUSOrCanada = userCountryCode === 'US' || userCountryCode === 'CA' || !userCountryCode;

  return { userIsUSOrCanada };
};
